import { render, staticRenderFns } from "./NormalSearchNav563.vue?vue&type=template&id=5befad27&scoped=true"
import script from "./NormalSearchNav563.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav563.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5befad27",
  null
  
)

export default component.exports